import { useCallback } from "react";
import { useFetchAllLatestBundlePacks } from "illuminate/hooks/usePacksAPI";
import { PackTypes } from "illuminate/types";
import TagsFilterComponent from "./packs-list/tags-filter-component";
import { ATTRIBUTES } from "./packs-list/constants";
export const deserializePacks = ([
  { category, input_types, tags },
  { page, per_page, total, count, packs }
]) => {
  var _a;
  const auxAttributes = [...ATTRIBUTES];
  if (category == null ? void 0 : category.length)
    auxAttributes.push({
      id: "category",
      title: "Category",
      type: "STRING",
      filterable: true,
      filter_options: category.map((opt) => ({ value: opt, title: opt }))
    });
  if (tags == null ? void 0 : tags.length)
    auxAttributes.push({
      id: "tags",
      title: "Tags",
      type: "STRING",
      filterable: true,
      filter_options: tags.map((opt) => ({ value: opt, title: opt })),
      filter_component: TagsFilterComponent,
      hidden: true
    });
  if (input_types == null ? void 0 : input_types.length)
    auxAttributes.push({
      id: "input_types",
      title: "Input Types",
      type: "STRING",
      filterable: true,
      filter_options: input_types.map((opt) => ({ value: opt, title: opt })),
      hidden: true
    });
  return {
    attributes: auxAttributes,
    list: (_a = packs.map((pack) => ({ ...pack, id: pack.pack_id }))) != null ? _a : [],
    pagination: { total, page, per_page, count }
  };
};
export const buildEnableDisablePayload = (selectedPacks) => {
  const requestObject = {
    processing_pack_ids: [],
    spotlight_pack_ids: []
  };
  selectedPacks.forEach((pack) => {
    if (pack.type === PackTypes.PROCESSING) {
      requestObject.processing_pack_ids.push(pack.pack_id);
    } else if (pack.type === PackTypes.SPOTLIGHT) {
      requestObject.spotlight_pack_ids.push(pack.pack_id);
    }
  });
  return requestObject;
};
export const useGetRequirements = () => {
  const { fetchingAllPacks, allPacks } = useFetchAllLatestBundlePacks();
  const getRequiredPacks = useCallback(
    (inPack) => {
      var _a;
      return (_a = allPacks.filter((pack) => inPack.requirements.includes(pack.pack_id))) != null ? _a : [];
    },
    [allPacks]
  );
  const getRequiredByPacks = useCallback(
    (inPack) => {
      var _a;
      return (_a = allPacks.filter((pack) => pack.requirements.includes(inPack.pack_id))) != null ? _a : [];
    },
    [allPacks]
  );
  return {
    getRequiredPacks,
    getRequiredByPacks,
    fetchingAllPacks,
    allPacks
  };
};
export function buildIlluminateQuery(filters) {
  if (!filters || Object.keys(filters).length === 0) return "";
  const fDataFormatted = (fData) => {
    const normalizedData = Array.isArray(fData) ? fData : [fData];
    const strFData = normalizedData.map((value) => value).join(",");
    return `${strFData}`;
  };
  const normalizedFilters = Object.entries(filters).flatMap(([key, fData]) => {
    const normalizedData = Array.isArray(fData) ? fData : [fData];
    if (key !== "status") {
      return [[key, normalizedData]];
    }
    const statusFilters = [];
    if (normalizedData.includes("new")) {
      statusFilters.push(["is_new", ["true"]]);
    }
    if (normalizedData.includes("update")) {
      statusFilters.push(["update_available", ["true"]]);
    }
    return statusFilters;
  });
  return normalizedFilters.map(([key, fData]) => `${key}=${fDataFormatted(fData)}`).join("&");
}
export function capitalizeFirstLetter(s) {
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}
export function requiredLicenseMessage(requiredLicenses) {
  return `Requires ${requiredLicenses.map((l) => capitalizeFirstLetter(l)).join(" or ")} license`;
}
